import { useQuery } from "@apollo/client";
import useCapabilities, { useCanViewTasksBool } from "@/hooks/useCapabilities";
import { TASKS_QUERY } from "@/pages/tasks/queries";
import { TaskStageValues } from "@/types";
import { isInitialQueryLoading } from "../_utils/isInitialQueryLoading";

const UPCOMING_TASK_LIMIT = 3;

export default function useUpcomingTasks() {
  const { id: currentUserId } = useCapabilities();
  const canViewTasks = useCanViewTasksBool();

  const { data, previousData, loading, networkStatus, error } = useQuery(TASKS_QUERY, {
    variables: {
      first: UPCOMING_TASK_LIMIT,
      input: {
        assignedToId: currentUserId ?? undefined,
        stage: [TaskStageValues.OPEN]
      },
      orderBy: {
        field: "DUE_DATE",
        direction: "ASC"
      }
    },
    skip: !currentUserId || !canViewTasks,
    fetchPolicy: "cache-and-network"
  });

  const resolvedData = data ?? previousData;
  const tasks = (resolvedData?.tasks?.nodes ?? []).filter(Boolean);

  return {
    tasks,
    totalOpenTaskCount: resolvedData?.tasks?.totalCount ?? 0,
    loading: isInitialQueryLoading({
      loading,
      networkStatus,
      itemCount: tasks.length,
      hasData: resolvedData !== undefined,
      error
    }),
    error: error as Error | undefined,
    canViewTasks
  };
}
